import MetricsRegistry from '../metrics-registry';

export enum InteractionStatus {
    SUCCESS = 'success',
    FAILURE = 'failure',
}
const SAMPLE_RATE = 0.01; // 1% sampling

class CoreInteractionMetrics extends MetricsRegistry {
    register3PALoadEvent(status: InteractionStatus) {
        this.registerClientSideEvent('3PA_load', { status });
    }

    registerMessageSendEvent(status: InteractionStatus) {
        this.registerClientSideEvent('message_send', { status });
    }

    registerLoginViaFormEvent(status: InteractionStatus, useBeacon = false) {
        this.registerClientSideEvent('login_via_form', { status }, useBeacon);
    }

    registerRegisterEvent(status: InteractionStatus, useBeacon = false) {
        this.registerClientSideEvent('register_via_form', { status }, useBeacon);
    }

    registerPayshipPayEvent(status: InteractionStatus, useBeacon = false) {
        this.registerClientSideEvent('payship_pay', { status }, useBeacon);
    }

    registerPayshipOrderEvent(status: InteractionStatus, useBeacon = false) {
        this.registerClientSideEvent('payship_order', { status }, useBeacon);
    }

    registerRevealNumberEvent(status: InteractionStatus) {
        this.registerClientSideEvent('buyer_reveal_number', { status });
    }

    registerRequestAQuoteEvent(status: InteractionStatus, formType: 'GT' | 'Bark') {
        this.registerClientSideEvent('bark_request_a_quote', { status, formType });
    }

    registerServerSideErrorEvent(errorCode: string | number | undefined, path: string) {
        this.registerServerSideEvent('server_side_error', { errorCode, path });
    }

    registerClientSideErrorEvent(path: string) {
        if (Math.random() >= SAMPLE_RATE) {
            return;
        }
        this.registerClientSideEvent('client_side_error', { path });
    }

    registerQuestionAnswerEvent(duration: number) {
        this.registerServerSideHistogramEvent('question_answer_duration', duration, {});
    }

    getModuleName() {
        return 'core_interaction';
    }

    getCountersToRegister() {
        return [
            { name: '3PA_load', labelNames: ['status'] },
            { name: 'message_send', labelNames: ['status'] },
            { name: 'login_via_form', labelNames: ['status'] },
            { name: 'register_via_form', labelNames: ['status'] },
            { name: 'payship_pay', labelNames: ['status'] },
            { name: 'payship_order', labelNames: ['status'] },
            { name: 'buyer_reveal_number', labelNames: ['status'] },
            { name: 'bark_request_a_quote', labelNames: ['status', 'formType'] },
            { name: 'server_side_error', labelNames: ['errorCode', 'path'] },
            { name: 'client_side_error', labelNames: ['path'] },
        ];
    }

    getHistogramsToRegister() {
        return [
            {
                name: 'question_answer_duration',
                labelNames: [],
                buckets: [
                    0.05, 0.1, 0.15, 0.2, 0.3, 0.4, 0.8, 1.2, 2.4, 5, 10, 20, 30, 60, 120, 240, 600,
                ],
            },
        ];
    }
}

export default new CoreInteractionMetrics();
